const React = require("react")

const { IconCalendar } = require("./calendar")

module.exports = {
  Calendar: (props) => <IconCalendar {...props} />
}



// WEBPACK FOOTER //
// ./src/shared/skin/icons/react-dates-range/index.js